<template>
    <v-container class="my-1">
        <h1>{{ $t('Bienvenido') }}: {{getProfile.first_name}} {{getProfile.last_name}}</h1>
        <v-layout align-center justify-center>
            <v-flex>
                <v-card
                        class="elevation-5"
                >
                    <v-img
                            v-show="(getProfile.roll === 1 || getProfile.roll === 2 || getProfile.roll === 5) && getProfile.wallpaper !== null"
                            :src="getProfile.wallpaper"
                    ></v-img>
                    <v-img
                            v-show="getProfile.wallpaper === null"
                            :src="require('../assets/bg-login.jpg')"
                    ></v-img>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import { mapGetters} from 'vuex'


    export default {
        name: 'Home',
        computed: {
            ...mapGetters(['getProfile']),
        }
    }
</script>
